import script from "./CardFontS3.vue?vue&type=script&setup=true&lang=js"
export * from "./CardFontS3.vue?vue&type=script&setup=true&lang=js"

import "./CardFontS3.vue?vue&type=style&index=0&id=524163ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524163ea"]])

export default __exports__